import { Injectable } from '@angular/core';
import {HttpServiceBase} from './http-service-base';
import {UserDetailsModel} from '../../modules/auth/models/user-details-model';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhoAmIHttpService extends  HttpServiceBase{


    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3827597313/WHOAMI+v1
    async whoAmI(): Promise<UserDetailsModel> {
        const url = `${this.serverAddress}/v1/whoami`;
        let response = await firstValueFrom(this.httpClient.get<UserDetailsModel>(url));
        return response
    }

}
